module.exports = __webpack_public_path__ + "static/media/Avatars_Female-13.1c1869b1.png";